import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { PriceLevel, Category } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

@Injectable()
export class PriceApi {
	private _eventsUrl = '/api/events/v1';
	private priceLevelApi = '/api/events/v2/priceLevels';

	constructor(private httpClient: HttpClient, private logger: Logger) {

	}

	public createPrice(priceLevel: PriceLevel): Observable<PriceLevel> {
		let body = JSON.stringify(priceLevel);
		return this.httpClient.post(this.priceLevelApi, body)
			.map(response => <PriceLevel>response.json())
			.catch(this.handleError)
	}

	public updatePrice(priceLevel: PriceLevel): Observable<PriceLevel> {
		let body = JSON.stringify({
			price: {
				money: {
					currency: "EUR",
					value: priceLevel.price.money.value
				},
				vat: priceLevel.price.vat
			},
			ticketFees: priceLevel.ticketFees,
			name: priceLevel.name,
			uuid: priceLevel.uuid,
			hideOnline: priceLevel.hideOnline,
			maxAllowed: priceLevel.maxAllowed,
			forSponsors: priceLevel.forSponsors,
			voucherNeeded: priceLevel.voucherNeeded,
			pos: priceLevel.pos,
		});
		return this.httpClient.put(priceLevel._links.self.href, body).map(
			response => priceLevel
		)
	}

	public deletePrice(priceLevel: PriceLevel) {
		return this.httpClient.delete(priceLevel._links.deleteWithReference.href)
	}



	public getStandardPriceLevel(url: string): Observable<PriceLevel> {
		return this.httpClient.get(url)
			.map(response => {
				return <PriceLevel>response.json()
			} )
			.catch(this.handleError);
	}
	public getReducedPriceLevels(url: string): Observable<PriceLevel[]> {
		return this.httpClient.get(url)
			.map(response => {
				return <PriceLevel[]>response.json()._embedded.priceLevels
			} )
			.catch(this.handleError);
	}

	public findByUuid(priceLevelUuid: string): Observable<PriceLevel> {
		return this.httpClient.get(this.priceLevelApi + "/search/findByUuid?uuid=" + priceLevelUuid)
			.map(response => <PriceLevel>response.json())
	}

	private handleError = (error: Response) => {
		if (error.status === 404) {
			return Observable.throw("404");
		} else {
			this.logger.error(error);
			return Observable.throw(error.json());
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/price-api.service.ts